import { Component, Input } from '@angular/core';

@Component({
  selector: 'adc-treeview',
  templateUrl: './adc-treeview.component.html',
  styleUrls: ['./adc-treeview.component.scss'],
  standalone: false
})
export class AdcTreeviewComponent {
  showChild!: boolean;
  showgrandChild!: boolean;
  showChildArr: any = [];
  @Input('data') data: any;
  @Input('type') type: any;

  constructor() {
    this.showChild = false;
    this.showgrandChild = false;
  }

  onDblClick() {
    // this.showChild = !this.showChild;
    // this.showgrandChild = !this.showgrandChild;
    if(this.showChildArr.length > 0) {
      this.showChildArr = [];
    console.log('la la')
    } else {
      this.data.forEach((val:any) => {
        this.showChildArr.push(val.sub_document_id)
      });
    console.log('da da')
    }
    
  }

  showGrandChildFunc() {
    this.showgrandChild = !this.showgrandChild;
  }

  showChildFunc() {
    this.showChild = !this.showChild;
  }

  showChildren(id: any) {
    console.log(this.showChildArr)
    if(this.showChildArr.includes(id)) {
      this.showChildArr = this.showChildArr.filter((data: any) => data != id);
    } else {
      this.showChildArr.push(id);
    }
  }
}
